import { render } from "./SandboxJobDetail.vue?vue&type=template&id=bdd40f38&scoped=true"
import script from "./SandboxJobDetail.vue?vue&type=script&lang=js"
export * from "./SandboxJobDetail.vue?vue&type=script&lang=js"

import "./SandboxJobDetail.vue?vue&type=style&index=0&id=bdd40f38&scoped=true&lang=css"
import "./SandboxJobDetail.vue?vue&type=style&index=1&id=bdd40f38&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd40f38"]])

export default __exports__